import script from "./AddMandateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMandateModal.vue?vue&type=script&setup=true&lang=js"

import "./AddMandateModal.vue?vue&type=style&index=0&id=1d74691f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d74691f"]])

export default __exports__